import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface SidebarUniDriver extends BaseUniDriver {}
